// import React from 'react';
// import { useState } from 'react'
import Deck from './Deck/Deck.jsx';
import './Main.css';

function Main() {
  return (
    <div className="modern-app-container">
      <Deck />
    </div>
  );
}

export default Main;

